module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/result01-57c86922e60a3ce607ca9c9d978766d7.png";